import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#33375A',
      light: '#33375A',
      dark: '#33375A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F0F0F0',
      light: '#F0F0F0',
      dark: '#F0F0F0',
      contrastText: '#33375A',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: ['Roboto-Regular'].join(','),
  },
});
